import esriConfig from "@arcgis/core/config";
import "typeface-roboto";

export const appId = process.env.ARCGIS_APP_ID;
/**
 * Users Portal URL.
 */
export const portalUrl = "https://dchaudhuri.maps.arcgis.com"; // default Portal URL https://www.arcgis.com
export const proxyUrl = process.env.proxyUrl; //http://localhost/arcgisproxy/proxy.ashx//https://gisdemo1.cdmsmith.com/arcgisproxy/proxy.ashx

